<template>
  <!-- Menu -->
  <aside id="layout-menu" class="layout-menu menu-vertical menu bg-menu-theme">
    <div class="app-brand demo">
      <a href="/" class="app-brand-link">
        <div class="" style="width: 2.7rem">
          <img src="@/assets/img/logo-icon.svg" alt />
        </div>
        <span
          class="app-brand-text demo menu-text fw-bold"
          style="width: 7.5rem"
        >
          <img src="@/assets/img/logo-text.svg" alt />
        </span>
      </a>

      <a
        href="javascript:void(0);"
        class="layout-menu-toggle menu-link text-large ms-auto"
      >
        <i class="ti menu-toggle-icon d-none d-xl-block align-middle"></i>
        <i class="ti ti-x d-block d-xl-none ti-md align-middle"></i>
      </a>
    </div>

    <div class="menu-inner-shadow"></div>

    <ul class="menu-inner py-1">
      <!-- Dashboards -->

      <li class="menu-item" :class="{ active: this.$route.name == 'Home' }">
        <a
          href="/"
          @click.prevent="
            this.$router.push('/');
            closeMenu();
          "
          class="menu-link"
        >
          <i class="menu-icon tf-icons ti ti-smart-home"></i>
          <div data-i18n="Home">{{ $t("sidebar.dashboard") }}</div>
        </a>
      </li>

      <!-- Apps & Pages -->
      <li class="menu-header small">
        <span class="menu-header-text" data-i18n="Apps & Pages">{{
          $t("sidebar.pages")
        }}</span>
      </li>
      <li
        class="menu-item"
        :class="{ open: drops.accounts, active: drops.accounts }"
        v-if="
          hasPrivilege('accounts_view_index_accounts') ||
            hasPrivilege('accounts_view_search_accounts') ||
            hasPrivilege('accounts_view_index_online') ||
            hasPrivilege('accounts_view_search_online')
        "
      >
        <a
          href="javascript:void(0);"
          @click="toggleMenu('accounts')"
          class="menu-link menu-toggle"
        >
          <i class="menu-icon tf-icons ti ti-users"></i>
          <div data-i18n="Accounts">{{ $t("sidebar.accounts.accounts") }}</div>
        </a>
        <ul class="menu-sub">
          <li
            v-if="
              hasPrivilege('accounts_view_index_accounts') ||
                hasPrivilege('accounts_view_search_accounts')
            "
            class="menu-item"
            :class="{
              active: this.$route.name == 'Accounts',
            }"
          >
            <a
              href="/accounts"
              @click.prevent="
                this.$router.push('/accounts');
                closeMenu();
              "
              class="menu-link"
            >
              <div data-i18n="Subscribtions">
                {{ $t("sidebar.accounts.subscribtions") }}
              </div>
            </a>
          </li>
          <li
            v-if="
              hasPrivilege('accounts_view_index_online') ||
                hasPrivilege('accounts_view_search_online')
            "
            class="menu-item"
            :class="{ active: this.$route.name == 'OnlineSessions' }"
          >
            <a
              href="/sessions/online"
              @click.prevent="
                this.$router.push('/sessions/online');
                closeMenu();
              "
              class="menu-link"
            >
              <div data-i18n="OnlineSessions">
                {{ $t("sidebar.accounts.online_sessions") }}
              </div>
            </a>
          </li>
        </ul>
      </li>
      <li
        v-if="
          hasPrivilege('cards_view_index_batches') ||
            hasPrivilege('cards_view_search_batches') ||
            hasPrivilege('cards_view_index_cards') ||
            hasPrivilege('cards_view_search_cards') ||
            hasPrivilege('cards_view_index_batches_reseller')
        "
        class="menu-item"
        :class="{ open: drops.cards, active: drops.cards }"
      >
        <a
          href="javascript:void(0);"
          @click="toggleMenu('cards')"
          class="menu-link menu-toggle"
        >
          <i class="menu-icon tf-icons ti ti-cards"></i>
          <div data-i18n="Cards">{{ $t("sidebar.cards.cards") }}</div>
        </a>
        <ul class="menu-sub">
          <li
            v-if="
              hasPrivilege('cards_view_index_batches') ||
                hasPrivilege('cards_view_search_batches') ||
                hasPrivilege('cards_view_index_batches_reseller')
            "
            class="menu-item"
            :class="{ active: this.$route.name == 'CardsGroups' }"
          >
            <a
              href="/cards/groups"
              @click.prevent="
                this.$router.push('/cards/groups');
                closeMenu();
              "
              class="menu-link"
            >
              <div data-i18n="Subscribtions">
                {{ $t("sidebar.cards.groups") }}
              </div>
            </a>
          </li>
          <li
            v-if="
              hasPrivilege('cards_view_index_cards') ||
                hasPrivilege('cards_view_search_cards')
            "
            class="menu-item"
            :class="{ active: this.$route.name == 'Cards' }"
          >
            <a
              href="/cards"
              @click.prevent="
                this.$router.push('/cards');
                closeMenu();
              "
              class="menu-link"
            >
              <div data-i18n="Subscribtions">{{ $t("sidebar.cards.all") }}</div>
            </a>
          </li>
        </ul>
      </li>
      <li
        v-if="
          hasPrivilege('profiles_view_index_profiles') ||
            hasPrivilege('profiles_view_search_profiles')
        "
        class="menu-item"
        :class="{ active: this.$route.name == 'Profiles' }"
      >
        <a
          href="/profiles"
          @click.prevent="
            this.$router.push('/profiles');
            closeMenu();
          "
          class="menu-link"
        >
          <i class="menu-icon tf-icons ti ti-brand-databricks"></i>
          <div data-i18n="Subscribtions">
            {{ $t("sidebar.profiles.profiles") }}
          </div>
        </a>
      </li>
      <li
        v-if="
          hasPrivilege('nases_view_index_nases') ||
            hasPrivilege('nases_view_search_nases')
        "
        class="menu-item"
        :class="{ open: drops.nases, active: drops.nases }"
      >
        <a
          href="javascript:void(0);"
          @click="toggleMenu('nases')"
          class="menu-link menu-toggle"
        >
          <i class="menu-icon tf-icons ti ti-topology-star-3"></i>
          <div data-i18n="Nases">{{ $t("sidebar.nas") }}</div>
        </a>
        <ul class="menu-sub">
          <li
            class="menu-item"
            :class="{ active: this.$route.name == 'Networks' }"
          >
            <a
              href="/networks"
              @click.prevent="
                this.$router.push('/networks');
                closeMenu();
              "
              class="menu-link"
            >
              <div data-i18n="Nases">{{ $t("sidebar.nas") }}</div>
            </a>
          </li>
          <li
            class="menu-item"
            :class="{ active: this.$route.name == 'NetworkDevices' }"
          >
            <a
              href="/networks/devices"
              @click.prevent="
                this.$router.push('/networks/devices');
                closeMenu();
              "
              class="menu-link"
            >
              <div data-i18n="Nases">{{ $t("sidebar.nas_devices") }}</div>
            </a>
          </li>
        </ul>
        <!-- <a
          href="/networks"
          @click.prevent="
            this.$router.push('/networks');
            closeMenu();
          "
          class="menu-link"
        >
          <i class="menu-icon tf-icons ti ti-topology-star-3"></i>
          <div data-i18n="Subscribtions">{{ $t("sidebar.nas") }}</div>
        </a> -->
      </li>
      <li
        v-if="
          (hasPrivilege('support_tickets_view_index_support_tickets') ||
            hasPrivilege('support_tickets_view_search_support_tickets')) &&
            settings.features.ssra
        "
        class="menu-item"
        :class="{ active: this.$route.name == 'Support' }"
      >
        <a
          href="/support"
          @click.prevent="
            this.$router.push('/support');
            closeMenu();
          "
          class="menu-link"
        >
          <i class="menu-icon tf-icons ti ti-lifebuoy"></i>
          <div data-i18n="Subscribtions">
            {{ $t("sidebar.support_tickets") }}
          </div>
        </a>
      </li>
      <li
        v-if="hasPrivilege('system_ownership') && settings.features.ssra"
        class="menu-item"
        :class="{ active: this.$route.name == 'Notifications' }"
      >
        <a
          href="/notifications"
          @click.prevent="
            this.$router.push('/notifications');
            closeMenu();
          "
          class="menu-link"
        >
          <i class="menu-icon tf-icons ti ti-bell-ringing"></i>
          <div data-i18n="Subscribtions">
            {{ $t("sidebar.notifications.notifications") }}
          </div>
        </a>
      </li>
      <li
        v-if="hasPrivilege('map_view_map')"
        class="menu-item"
        :class="{ active: this.$route.name == 'Map' }"
      >
        <a
          href="/map"
          @click.prevent="
            this.$router.push('/map');
            closeMenu();
          "
          class="menu-link"
        >
          <i class="menu-icon tf-icons ti ti-map"></i>
          <div data-i18n="Map">
            {{ $t("sidebar.map") }}
          </div>
        </a>
      </li>
      <li
        class="menu-item"
        v-if="
          hasPrivilege('vouchers_view_index_batches') ||
            hasPrivilege('vouchers_view_search_batches') ||
            hasPrivilege('vouchers_view_index_vouchers') ||
            hasPrivilege('vouchers_view_search_vouchers')
        "
        :class="{ open: drops.vouchers, active: drops.vouchers }"
      >
        <a
          href="javascript:void(0);"
          @click.prevent="toggleMenu('vouchers')"
          class="menu-link menu-toggle"
        >
          <i class="menu-icon tf-icons ti ti-ticket"></i>
          <div data-i18n="Vouchers">{{ $t("sidebar.credits_vouchers") }}</div>
        </a>
        <ul class="menu-sub">
          <li
            class="menu-item"
            v-if="
              hasPrivilege('vouchers_view_index_batches') ||
                hasPrivilege('vouchers_view_search_batches')
            "
            :class="{ active: this.$route.name == 'VouchersBatches' }"
          >
            <a
              href="/vouchers/batches"
              @click.prevent="
                this.$router.push('/vouchers/batches');
                closeMenu();
              "
              class="menu-link"
            >
              <div data-i18n="VouchersBatches">
                {{ $t("sidebar.vouchers_batches") }}
              </div>
            </a>
          </li>
          <li
            class="menu-item"
            v-if="
              hasPrivilege('vouchers_view_index_vouchers') ||
                hasPrivilege('vouchers_view_search_vouchers')
            "
            :class="{ active: this.$route.name == 'Vouchers' }"
          >
            <a
              href="/vouchers"
              @click.prevent="
                this.$router.push('/vouchers');
                closeMenu();
              "
              class="menu-link"
            >
              <div data-i18n="Vouchers">
                {{ $t("sidebar.all_vouchers") }}
              </div>
            </a>
          </li>
        </ul>
      </li>
      <li
        v-if="settings.features.mikrotik_services"
        class="menu-item"
        :class="{ open: drops.services, active: drops.services }"
      >
        <a
          href="javascript:void(0);"
          @click.prevent="toggleMenu('services')"
          class="menu-link menu-toggle"
        >
          <i class="menu-icon tf-icons ti ti-assembly"></i>
          <div data-i18n="Services">{{ $t("sidebar.services.services") }}</div>
        </a>
        <ul class="menu-sub">
          <li
            v-if="hasPrivilege('system_ownership')"
            class="menu-item"
            :class="{ active: this.$route.name == 'Mikrotik' }"
          >
            <a
              href="/mikrotik"
              @click.prevent="
                this.$router.push('/mikrotik');
                closeMenu();
              "
              class="menu-link"
            >
              <div data-i18n="Mikrotik">
                {{ $t("sidebar.services.mikrotik") }}
              </div>
            </a>
          </li>
          <li
            class="menu-item"
            :class="{ active: this.$route.name == 'MikrotikLog' }"
          >
            <a
              href="/mikrotik/log"
              @click.prevent="
                this.$router.push('/mikrotik/log');
                closeMenu();
              "
              class="menu-link"
            >
              <div>
                {{ $t("sidebar.services.mikrotik_log") }}
              </div>
            </a>
          </li>
          <li
            v-if="hasPrivilege('settings_bandwidth_control')"
            class="menu-item"
            :class="{ active: this.$route.name == 'Bandwidth' }"
          >
            <a
              href="/bandwidth"
              @click.prevent="
                this.$router.push('/bandwidth');
                closeMenu();
              "
              class="menu-link"
            >
              <div data-i18n="Bandwidth Control">
                {{ $t("sidebar.services.bandwidth") }}
              </div>
            </a>
          </li>
          <li
            v-if="hasPrivilege('settings_iptv') && settings.features.ssra"
            class="menu-item"
            :class="{ active: this.$route.name == 'IPTV' }"
          >
            <a
              href="/iptv"
              @click.prevent="
                this.$router.push('/iptv');
                closeMenu();
              "
              class="menu-link"
            >
              <div data-i18n="IPTV">IPTV</div>
            </a>
          </li>
          <li
            v-if="hasPrivilege('system_ownership') && settings.type == 'local'"
            class="menu-item"
            :class="{ active: this.$route.name == 'VpnConnections' }"
          >
            <a
              href="/vpns"
              @click.prevent="
                this.$router.push('/vpns');
                closeMenu();
              "
              class="menu-link"
            >
              <div data-i18n="VPNS">VPN</div>
            </a>
          </li>
          <li
            v-if="
              hasPrivilege('settings_ssradius_services') &&
                settings.type == 'local'
            "
            class="menu-item"
            :class="{ active: this.$route.name == 'SServices' }"
          >
            <a
              href="/sservices"
              @click.prevent="
                this.$router.push('/sservices');
                closeMenu();
              "
              class="menu-link"
            >
              <div data-i18n="IPTV">SSRadius</div>
            </a>
          </li>
        </ul>
      </li>

      <li
        v-if="
          hasPrivilege('admins_view_index_admins') ||
            hasPrivilege('admins_view_search_admins') ||
            hasPrivilege('admins_privileges_groups') ||
            hasPrivilege('reseller_add_reseller')
        "
        class="menu-item"
        :class="{ open: drops.admins, active: drops.admins }"
      >
        <a
          href="javascript:void(0);"
          @click="toggleMenu('admins')"
          class="menu-link menu-toggle"
        >
          <i class="menu-icon tf-icons ti ti-users-group"></i>
          <div data-i18n="admins">{{ $t("sidebar.users") }}</div>
        </a>
        <ul class="menu-sub">
          <li
            v-if="
              (hasPrivilege('admins_view_index_admins') ||
                hasPrivilege('admins_view_search_admins')) &&
                settings.features.admins
            "
            class="menu-item"
            :class="{ active: this.$route.name == 'Admins' }"
          >
            <a
              href="/admins"
              @click.prevent="
                this.$router.push('/admins');
                closeMenu();
              "
              class="menu-link"
            >
              <i class="menu-icon tf-icons ti ti-user-scan"></i>
              <div data-i18n="Subscribtions">{{ $t("sidebar.admins") }}</div>
            </a>
          </li>
          <li
            v-if="
              (hasPrivilege('admins_view_index_admins') ||
                hasPrivilege('admins_view_search_admins') ||
                hasPrivilege('reseller_add_reseller')) &&
                settings.features.resellers
            "
            class="menu-item"
            :class="{ active: this.$route.name == 'Resellers' }"
          >
            <a
              href="/resellers"
              @click.prevent="
                this.$router.push('/resellers');
                closeMenu();
              "
              class="menu-link"
            >
              <i class="menu-icon tf-icons ti ti-users-group"></i>
              <div data-i18n="Subscribtions">{{ $t("sidebar.resellers") }}</div>
            </a>
          </li>

          <li
            v-if="
              hasPrivilege('admins_privileges_groups') &&
                settings.features.admins
            "
            class="menu-item"
            :class="{ active: this.$route.name == 'PrivilegesGroups' }"
          >
            <a
              href="/groups"
              @click.prevent="
                this.$router.push('/groups');
                closeMenu();
              "
              class="menu-link"
            >
              <i class="menu-icon tf-icons ti ti-users-group"></i>
              <div data-i18n="Subscribtions">
                {{ $t("sidebar.privileges_groups") }}
              </div>
            </a>
          </li>
        </ul>
      </li>

      <li
        v-if="
          hasPrivilege('accounting_view_user_bills') ||
            hasPrivilege('accounting_view_bills') ||
            hasPrivilege('accounting_search_bills') ||
            hasPrivilege('accounting_view_user_transactions') ||
            hasPrivilege('accounting_view_transactions') ||
            hasPrivilege('accounting_search_transactions') ||
            hasPrivilege('accounting_admins_view_bills') ||
            hasPrivilege('accounting_admins_search_bills') ||
            hasPrivilege('accounting_view_sales') ||
            hasPrivilege('accounting_search_sales')
        "
        class="menu-item"
        :class="{ open: drops.accounting, active: drops.accounting }"
      >
        <a
          href="javascript:void(0);"
          @click="toggleMenu('accounting')"
          class="menu-link menu-toggle"
        >
          <i class="menu-icon tf-icons ti ti-building-bank"></i>
          <div data-i18n="Accounting">{{ $t("sidebar.accounting") }}</div>
        </a>
        <ul class="menu-sub">
          <li
            v-if="
              hasPrivilege('accounting_view_user_bills') ||
                hasPrivilege('accounting_view_bills') ||
                hasPrivilege('accounting_search_bills') ||
                hasPrivilege('accounting_vouchers_view_own_bills') ||
                hasPrivilege('accounting_vouchers_view_all_bills')
            "
            class="menu-item"
            :class="{ active: this.$route.name == 'Bills' }"
          >
            <a
              href="/bills"
              @click.prevent="
                this.$router.push('/bills');
                closeMenu();
              "
              class="menu-link"
            >
              <div data-i18n="Bills">{{ $t("sidebar.bills") }}</div>
            </a>
          </li>
          <li
            v-if="hasPrivilege('accounting_admins_view_bills')"
            class="menu-item"
            :class="{ active: this.$route.name == 'ResellersBills' }"
          >
            <a
              href="/bills/resellers"
              @click.prevent="
                this.$router.push('/bills/resellers');
                closeMenu();
              "
              class="menu-link"
            >
              <div data-i18n="Bills">{{ $t("sidebar.resellers_bills") }}</div>
            </a>
          </li>
          <li
            v-if="hasPrivilege('accounting_cards_view_bills')"
            class="menu-item"
            :class="{ active: this.$route.name == 'CardsBills' }"
          >
            <a
              href="/bills/cards"
              @click.prevent="
                this.$router.push('/bills/cards');
                closeMenu();
              "
              class="menu-link"
            >
              <div data-i18n="CardsBills">{{ $t("sidebar.cards_bills") }}</div>
            </a>
          </li>
          <li
            v-if="
              hasPrivilege('accounting_vouchers_view_own_bills') ||
                hasPrivilege('accounting_vouchers_view_all_bills')
            "
            class="menu-item"
            :class="{ active: this.$route.name == 'VouchersBills' }"
          >
            <a
              href="/bills/vouchers"
              @click.prevent="
                this.$router.push('/bills/vouchers');
                closeMenu();
              "
              class="menu-link"
            >
              <div data-i18n="VouchersBills">
                {{ $t("sidebar.vouchers_bills") }}
              </div>
            </a>
          </li>
          <li
            v-if="
              hasPrivilege('accounting_view_sales') ||
                hasPrivilege('accounting_search_sales')
            "
            class="menu-item"
            :class="{ active: this.$route.name == 'Sales' }"
          >
            <a
              href="/sales"
              @click.prevent="
                this.$router.push('/sales');
                closeMenu();
              "
              class="menu-link"
            >
              <div data-i18n="Sales">{{ $t("sidebar.sales") }}</div>
            </a>
          </li>
          <li
            v-if="
              hasPrivilege('accounting_view_user_transactions') ||
                hasPrivilege('accounting_view_transactions') ||
                hasPrivilege('accounting_search_transactions')
            "
            class="menu-item"
            :class="{ active: this.$route.name == 'MoneyT' }"
          >
            <a
              href="/money-transactions"
              @click.prevent="
                this.$router.push('/money-transactions');
                closeMenu();
              "
              class="menu-link"
            >
              <div data-i18n="Money transactions">
                {{ $t("sidebar.transactions") }}
              </div>
            </a>
          </li>
        </ul>
      </li>
      <li
        class="menu-item"
        :class="{ open: drops.ipadresses, active: drops.ipadresses }"
        v-if="
          hasPrivilege('ip_addresses_view_public_ip_addresses') ||
            hasPrivilege('ip_addresses_edit_public_ip_addresses') ||
            hasPrivilege('ip_addresses_view_private_ip_pools') ||
            hasPrivilege('ip_addresses_edit_private_ip_pools')
        "
      >
        <a
          href="javascript:void(0);"
          @click.prevent="toggleMenu('ipadresses')"
          class="menu-link menu-toggle"
        >
          <i class="menu-icon tf-icons ti ti-topology-star-ring-3"></i>
          <div data-i18n="IpAdresses">{{ $t("sidebar.ips") }}</div>
        </a>
        <ul class="menu-sub">
          <li
            class="menu-item"
            v-if="
              hasPrivilege('ip_addresses_view_public_ip_addresses') ||
                hasPrivilege('ip_addresses_edit_public_ip_addresses')
            "
            :class="{ active: this.$route.name == 'Ippublic' }"
          >
            <a
              href="/ippublic"
              @click.prevent="
                this.$router.push('/ippublic');
                closeMenu();
              "
              class="menu-link"
            >
              <div data-i18n="Public">{{ $t("sidebar.public_ips") }}</div>
            </a>
          </li>
          <li
            class="menu-item"
            v-if="
              hasPrivilege('ip_addresses_view_private_ip_pools') ||
                hasPrivilege('ip_addresses_edit_private_ip_pools')
            "
            :class="{ active: this.$route.name == 'PrivatePools' }"
          >
            <a
              href="/privatepools"
              @click.prevent="
                this.$router.push('/privatepools');
                closeMenu();
              "
              class="menu-link"
            >
              <div data-i18n="Private Pools">
                {{ $t("sidebar.private_ips") }}
              </div>
            </a>
          </li>
        </ul>
      </li>
      <li class="menu-item" :class="{ active: this.$route.name == 'Sessions' }">
        <a
          href="/sessions"
          @click.prevent="
            this.$router.push('/sessions');
            closeMenu();
          "
          class="menu-link"
        >
          <i class="menu-icon tf-icons ti ti-license"></i>
          <div data-i18n="Sessions Log">{{ $t("sidebar.sessions_log") }}</div>
        </a>
      </li>
      <li
        class="menu-item"
        :class="{ active: this.$route.name == 'Operations' }"
      >
        <a
          href="/operations"
          @click.prevent="
            this.$router.push('/operations');
            closeMenu();
          "
          class="menu-link"
        >
          <i class="menu-icon tf-icons ti ti-report-search"></i>
          <div data-i18n="Operations Log">{{ $t("sidebar.admins_log") }}</div>
        </a>
      </li>
      <li
        v-if="hasPrivilege('reports_print')"
        class="menu-item"
        :class="{ active: this.$route.name == 'Reports' }"
      >
        <a
          href="/reports"
          @click.prevent="
            this.$router.push('/reports');
            closeMenu();
          "
          class="menu-link"
        >
          <i class="menu-icon tf-icons ti ti-chart-bar"></i>
          <div data-i18n="Reports">{{ $t("sidebar.reports") }}</div>
        </a>
      </li>
      <li
        v-if="
          hasPrivilege('settings_update_settings') ||
            hasPrivilege('settings_view_settings') ||
            hasPrivilege('settings_view_license')
        "
        class="menu-item"
        :class="{ active: this.$route.name == 'Settings' }"
      >
        <a
          href="/settings"
          @click.prevent="
            this.$router.push('/settings');
            closeMenu();
          "
          class="menu-link"
        >
          <i class="menu-icon tf-icons ti ti-settings"></i>
          <div data-i18n="Settings">{{ $t("sidebar.settings.settings") }}</div>
        </a>
      </li>

      <!-- Misc -->
      <li class="menu-header small">
        <span class="menu-header-text" data-i18n="Misc">{{
          $t("sidebar.miscs")
        }}</span>
      </li>
      <li class="menu-item">
        <a href="https://wa.me/31685757294" class="menu-link">
          <i class="menu-icon tf-icons ti ti-lifebuoy"></i>
          <div data-i18n="Support">{{ $t("sidebar.support") }}</div>
        </a>
      </li>
      <li class="menu-item">
        <a href="https://ssradius.com" class="menu-link">
          <i class="menu-icon tf-icons ti ti-file-description"></i>
          <div data-i18n="Documentation">{{ $t("sidebar.docs") }}</div>
        </a>
      </li>
      <li
        v-if="settings.type == 'local'"
        class="text-center w-full text-sm pt-2 pb-4"
      >
        {{ settings.update_name }}
      </li>
    </ul>
  </aside>
  <!-- / Menu -->
</template>
<script>
import "../assets/vendor/js/menu.js";
import { mapGetters } from "vuex";
import { hasPrivilege } from "../global_constants.js";
export default {
  name: "Menu",
  data() {
    return {
      drops: {
        accounts: false,
        cards: false,
        profiles: false,
        support_tickets: false,
        notifications: false,
        services: false,
        admins: false,
        resellers: false,
        accounting: false,
        settings: false,
        nases: false,
      },
    };
  },
  computed: {
    ...mapGetters(["user", "settings"]),
  },
  mounted() {
    // Initialize menu togglers and bind click on each
    let menuToggler = document.querySelectorAll(".layout-menu-toggle");
    menuToggler.forEach((item) => {
      item.addEventListener("click", (event) => {
        event.preventDefault();
        window.Helpers.toggleCollapsed();
        // Enable menu state with local storage support if enableMenuLocalStorage = true from config.js
        if (config.enableMenuLocalStorage && !window.Helpers.isSmallScreen()) {
          try {
            localStorage.setItem(
              "templateCustomizer-" + window.templateName + "--LayoutCollapsed",
              String(window.Helpers.isCollapsed()),
            );
            // Update customizer checkbox state on click of menu toggler
            let layoutCollapsedCustomizerOptions = document.querySelector(
              ".template-customizer-layouts-options",
            );
            if (layoutCollapsedCustomizerOptions) {
              let layoutCollapsedVal = window.Helpers.isCollapsed()
                ? "collapsed"
                : "expanded";
              layoutCollapsedCustomizerOptions
                .querySelector(`input[value="${layoutCollapsedVal}"]`)
                .click();
            }
          } catch (e) {}
        }
      });
    });
    import("../assets/vendor/js/menu.js");
    this.initCheckRoute();
  },
  methods: {
    hasPrivilege(privilege) {
      return hasPrivilege(this.user, privilege);
    },
    initCheckRoute() {
      let currentRoute = this.$route.name;
      if (["Accounts", "OnlineSessions"].includes(currentRoute)) {
        this.drops.accounts = true;
      } else if (["Cards", "CardsGroups"].includes(currentRoute)) {
        this.drops.cards = true;
      } else if (["Profiles"].includes(currentRoute)) {
        this.drops.profiles = true;
      } else if (["Support"].includes(currentRoute)) {
        this.drops.support_tickets = true;
      } else if (["Notifications"].includes(currentRoute)) {
        this.drops.notifications = true;
      } else if (
        ["Mikrotik", "MikrotikLog", "Bandwidth", "IPTV", "SServices"].includes(
          currentRoute,
        )
      ) {
        this.drops.services = true;
      } else if (
        ["Admins", "Resellers", "PrivilegesGroups"].includes(currentRoute)
      ) {
        this.drops.admins = true;
      } else if (
        ["Bills", "ResellersBills", "CardsBills", "Sales", "MoneyT"].includes(
          currentRoute,
        )
      ) {
        this.drops.accounting = true;
      } else if (["Ippublic", "PrivatePools"].includes(currentRoute)) {
        this.drops.ipadresses = true;
      } else if (["Networks", "NetworkDevices"].includes(currentRoute)) {
        this.drops.nases = true;
      } else {
        this.drops.accounts = true;
      }
    },
    closeMenu() {
      if (window.Helpers.isSmallScreen()) {
        window.Helpers.toggleCollapsed();
        // Enable menu state with local storage support if enableMenuLocalStorage = true from config.js
        if (config.enableMenuLocalStorage && !window.Helpers.isSmallScreen()) {
          try {
            localStorage.setItem(
              "templateCustomizer-" + window.templateName + "--LayoutCollapsed",
              String(window.Helpers.isCollapsed()),
            );
            // Update customizer checkbox state on click of menu toggler
            let layoutCollapsedCustomizerOptions = document.querySelector(
              ".template-customizer-layouts-options",
            );
            if (layoutCollapsedCustomizerOptions) {
              let layoutCollapsedVal = window.Helpers.isCollapsed()
                ? "collapsed"
                : "expanded";
              layoutCollapsedCustomizerOptions
                .querySelector(`input[value="${layoutCollapsedVal}"]`)
                .click();
            }
          } catch (e) {}
        }
      }
    },
    toggleMenu(menu) {
      var previous_state = this.drops[menu];
      this.drops.accounts = false;
      this.drops.cards = false;
      this.drops.profiles = false;
      this.drops.support_tickets = false;
      this.drops.notifications = false;
      this.drops.services = false;
      this.drops.admins = false;
      this.drops.resellers = false;
      this.drops.accounting = false;
      this.drops.settings = false;
      this.drops.nases = false;

      this.drops[menu] = !previous_state;
    },
  },
};
</script>
